import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { fetchCustomerDashboardData } from '../actions';

const REQUEST_TIMEOUT = 30000;

function fetchWithTimeout(params) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Request timed out')), REQUEST_TIMEOUT);
    fetchCustomerDashboardData(params)
      .then((res) => { clearTimeout(timer); resolve(res); })
      .catch((err) => { clearTimeout(timer); reject(err); });
  });
}

export default function useCustomerDashboard(filterParams = {}) {
  const commonReducer = useSelector((state) => state.root.commonReducer);
  const token = window.localStorage.getItem('token');

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  } = useQuery(
    ['customerDashboard', commonReducer.user_id, filterParams.from, filterParams.to],
    () => fetchWithTimeout(filterParams),
    {
      enabled: !!token && !!commonReducer.user_id,
      retry: false,
      staleTime: 0,
      cacheTime: 0,
    }
  );

  const httpStatus = error?.response?.status;
  const apiMessage = error?.response?.data?.message;

  return {
    dashboardData: data || null,
    isLoading: isLoading || isFetching,
    isError,
    httpStatus,
    apiMessage,
    refetch,
  };
}
